const FRAUD_FAILURE_MODAL = 'FRAUD_FAILURE_MODAL';
const NOTIFICATION_MODAL = 'NOTIFICATION_MODAL';
const POST_ACTIVATION_MODAL = 'POST_ACTIVATION_MODAL';
const POST_DEACTIVATION_MODAL = 'POST_DEACTIVATION_MODAL';
const PAID_INCLUSION_PAYMENT_MODAL = 'PAID_INCLUSION_PAYMENT_MODAL';
const PAID_INCLUSION_POST_PUBLISH_MODAL = 'PAID_INCLUSION_POST_PUBLISH_MODAL';
const PAID_INCLUSION_VALUE_PROP_MODAL = 'PAID_INCLUSION_VALUE_PROP_MODAL';
const PAID_INCLUSION_DEACTIVATION_MODAL = 'PAID_INCLUSION_DEACTIVATION_MODAL';
const BLOCKED_USER_MODAL = 'BLOCKED_USER_MODAL';
const PAYMENT_INFO_MODAL = 'PAYMENT_INFO_MODAL';
const CONSOLIDATED_PROPERTY_LIST_MODAL = 'CONSOLIDATED_PROPERTY_LIST_MODAL';
const USER_MANAGEMENT_PROPERTY_LIST_MODAL = 'USER_MANAGEMENT_PROPERTY_LIST_MODAL';
const CONFIRMATION_MODAL = 'CONFIRMATION_MODAL';
const EDIT_UNIT_MODAL = 'EDIT_UNIT_MODAL';
const SELECT_TOUR_MODAL = 'SELECT_TOUR_MODAL';
const VIEW_TOUR_MODAL = 'VIEW_TOUR_MODAL';
const PROPERTY_PICKER_MODAL = 'PROPERTY_PICKER_MODAL';
const RESEND_COMPANY_INVITE_MODAL = 'RESEND_COMPANY_INVITE_MODAL';
const BOOST_AD_PREVIEWS = 'BOOST_AD_PREVIEWS';
const ACTIVATION_ERROR_MODAL = 'ACTIVATION_ERROR_MODAL';
const BILLING_ADD_PAYMENT_MODAL = 'BILLING_ADD_PAYMENT_MODAL';
const MANAGE_CLAIM_CONTACT_METHODS_MODAL = 'MANAGE_CLAIM_CONTACT_METHODS_MODAL';

const ModalConstants = {
    // TODO: clean up
    MODAL_ADD_PROPERTY_UPDATE_DISPLAY: 'MODAL_ADD_PROPERTY_UPDATE_DISPLAY',
    MODAL_SYNDICATION_STATUS_UPDATE: 'MODAL_SYNDICATION_STATUS_UPDATE',
    MODAL_ENABLE_APPLICATIONS_UPDATE_DISPLAY: 'MODAL_ENABLE_APPLICATIONS_UPDATE_DISPLAY',
    MODAL_IMAGE_CAROUSEL_UPDATE_DISPLAY: 'MODAL_IMAGE_CAROUSEL_UPDATE_DISPLAY',
    MODAL_VERIFY_EMAIL_UPDATE_DISPLAY: 'MODAL_VERIFY_EMAIL_UPDATE_DISPLAY',
    MODAL_VERIFY_EMAIL_FAILURE_UPDATE_DISPLAY: 'MODAL_VERIFY_EMAIL_FAILURE_UPDATE_DISPLAY',

    FRAUD_FAILURE_MODAL,
    BLOCKED_USER_MODAL,
    POST_ACTIVATION_MODAL,
    POST_DEACTIVATION_MODAL,
    NOTIFICATION_MODAL,
    PAID_INCLUSION_VALUE_PROP_MODAL,
    PAID_INCLUSION_PAYMENT_MODAL,
    PAID_INCLUSION_POST_PUBLISH_MODAL,
    PAID_INCLUSION_DEACTIVATION_MODAL,
    PAYMENT_INFO_MODAL,
    CONSOLIDATED_PROPERTY_LIST_MODAL,
    USER_MANAGEMENT_PROPERTY_LIST_MODAL,
    CONFIRMATION_MODAL,
    EDIT_UNIT_MODAL,
    SELECT_TOUR_MODAL,
    VIEW_TOUR_MODAL,
    PROPERTY_PICKER_MODAL,
    RESEND_COMPANY_INVITE_MODAL,
    BOOST_AD_PREVIEWS,
    ACTIVATION_ERROR_MODAL,
    BILLING_ADD_PAYMENT_MODAL,
    MANAGE_CLAIM_CONTACT_METHODS_MODAL,

    MODAL_PARENT_SELECTOR: 'app-root .App',
};

export default ModalConstants;
